const GALLERY_VIDEO_EXT_RE = /\.(mp4|webm|mov|m4v|ogg|ogv)$/i;

/** True when a stored key or URL points at a video (by path / query extension). */
export function isGalleryVideoUrl(url: string | null | undefined): boolean {
  if (!url?.trim()) {
    return false;
  }

  const raw = url.trim();
  if (raw.startsWith('blob:')) {
    return false;
  }

  const withoutHash = raw.split('#')[0];
  const withoutQuery = withoutHash.split('?')[0];
  return GALLERY_VIDEO_EXT_RE.test(withoutQuery);
}

function guessVideoMimeType(key: string): string {
  const lower = key.toLowerCase();
  if (lower.endsWith('.webm')) return 'video/webm';
  if (lower.endsWith('.mov')) return 'video/quicktime';
  if (lower.endsWith('.m4v')) return 'video/x-m4v';
  if (lower.endsWith('.ogg') || lower.endsWith('.ogv')) return 'video/ogg';
  return 'video/mp4';
}

export function toTypedVideoBlob(blob: Blob, storageKey: string): Blob {
  if (blob.type && blob.type !== 'application/octet-stream') {
    return blob;
  }

  return new Blob([blob], { type: guessVideoMimeType(storageKey) });
}
